"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSignupTemplate = void 0;
const lit_1 = require("lit");
const lit_html_1 = require("lit-html");
const decorators_js_1 = require("lit/decorators.js");
const typedi_1 = require("typedi");
const control_1 = require("@common/form/control");
const auth_1 = require("@auth/services/auth");
const page_1 = require("@common/services/page");
const translation_1 = require("@translation/services/translation");
const popup_1 = require("../services/popup");
/**
 * Открывает окно
 * Safari не открывает окно если вызывается из асинхронного метода
 */
function openWindow(link) {
    window.open(link, 'auth', 'width=770, height=700, scrollbars=yes, top=180, scrollbars=yes"');
}
/**
 * Всплывающее окно аутентификации пользователя
 */
let LoginPopup = class LoginPopup extends lit_1.LitElement {
    /**
     * Конструктор
     */
    constructor() {
        super();
        /**
         * Загрузка
         */
        this.loading = false;
        /**
         * Видимость пароля
         */
        this.shownPassword = false;
        /**
         * Видимость повторить пароль
         */
        this.shownPasswordConfirm = false;
        /**
         * Форма
         */
        this.form = new control_1.Form({
            mail: new control_1.TextControl(''),
            password: new control_1.TextControl(''),
            repeatPassword: new control_1.TextControl(''),
        });
        this.signup = this.signup.bind(this);
        this.socialAuthSuccessCallback = this.socialAuthSuccessCallback.bind(this);
        this.authService = typedi_1.Container.get(auth_1.AuthService);
        this.translationService = typedi_1.Container.get(translation_1.TranslationService);
        this.popupService = typedi_1.Container.get(popup_1.PopupService);
        this.pageManager = typedi_1.Container.get(page_1.PageManager);
    }
    /**
     * Устанавливает корень структуры
     */
    createRenderRoot() {
        return this;
    }
    /**
     * Регистрирует пользователя
     */
    signup() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            this.form.resetErrors();
            this.validateRepeatPasswordField();
            if (!this.form.isValid()) {
                this.loading = false;
                return;
            }
            try {
                const { mail, password } = this.form.getValue();
                yield this.authService.signup(mail, password);
                this.complete();
            }
            catch (err) {
                if (err.errors) {
                    this.form.setErrors(err.errors);
                }
                this.loading = false;
            }
        });
    }
    /**
     * Авторизовывает пользователя через соц.сеть
     */
    loginBySocial(type) {
        return __awaiter(this, void 0, void 0, function* () {
            window.socialAuthSuccessCallback = this.socialAuthSuccessCallback;
            openWindow('about:blank');
            try {
                switch (type) {
                    case 'google':
                        let data = yield this.authService.getGoogleLink();
                        openWindow(data.data.link);
                        break;
                    case 'facebook':
                        let data2 = yield this.authService.getFacebookLink();
                        openWindow(data2.data.link);
                        break;
                    case 'apple':
                        let data3 = yield this.authService.getAppleLink();
                        openWindow(data3.data.link);
                        break;
                }
            }
            catch (err) {
                alert(err.message || this.translationService.instant('genericerror.title'));
            }
        });
    }
    /**
     * Генерирует представление
     */
    render() {
        this.popupService.toggleArtScheme(this.parentElement);
        return (0, lit_html_1.html) `
            <div class="modal fade" tabindex="-1" aria-labelledby="Signup" aria-hidden="true">
                <div class="modal-dialog modal-fullscreen modal-md modal-dialog-centered">
                    <div class="modal-content">
                        <header class="art-modal__header">
                            <button class="button-close button-close--black" type="button" data-bs-dismiss="modal" aria-label="close">
                                <span class="close__icon" aria-hidden="true"></span>
                            </button>
                        </header>
    
                        <div class="art-modal__body">
                            <h2 class="modal-title">
                                ${this.translationService.instant('aa_signup')}
                            </h2>
                            <div class="modal-title-checkout">
                                ${this.translationService.instant('sign_up_to_continue')}
                            </div>
                            <div class="field-wrap gap-20 justify-content-center social-wrapper">
                                <button class="button button--transparent button-social" @click="${() => this.loginBySocial('google')}" ?disabled="${this.loading}">
                                    <svg class="button__icon">><use href="/css/icons.svg#art-google"/></svg>
                                </button>
                                <button class="button button--transparent button-social" @click="${() => this.loginBySocial('apple')}" ?disabled="${this.loading}">
                                    <svg class="button__icon" style="margin-top: -4px"><use href="/css/icons.svg#art-apple"/></svg>
                                </button>
                            </div>
                            <div class="field-wrap">
                                <art-text-field class="art-field" 
                                name="mail" 
                                placeholder="${this.translationService.instant('av_E_mail')}" 
                                .control="${this.form.get('mail')}" @enter="${this.signup}"></art-text-field>
                            </div>
                            <div class="field-wrap">
                                <art-text-field class="art-field" 
                                type="${this.shownPassword ? 'text' : 'password'}" 
                                name="password" 
                                placeholder="${this.translationService.instant('password')}" 
                                .control="${this.form.get('password')}" .postfix=${(0, lit_html_1.html) `
                                <button class="button art-field__icon eye-button" @click=${() => {
            var _a;
            this.shownPassword = !this.shownPassword;
            (_a = this.form.get('password')) === null || _a === void 0 ? void 0 : _a.resetError();
        }}>                                    
                                    <svg class="button__icon"><use href="/css/icons.svg#art-${this.shownPassword ? 'eye-off' : 'eye'}"/></svg>
                                </button>
                                `} @enter="${this.signup}"></art-text-field>
                            </div>

                            <div class="field-wrap" hidden="${this.shownPassword}">
                                <art-text-field 
                                class="art-field" 
                                type="${this.shownPasswordConfirm ? 'text' : 'password'}" 
                                name="repeatPassword" 
                                placeholder="${this.translationService.instant('repeatpassword')}" 
                                .control="${this.form.get('repeatPassword')}"  .postfix=${(0, lit_html_1.html) `
                                <button class="button art-field__icon eye-button" @click=${() => {
            var _a;
            this.shownPasswordConfirm = !this.shownPasswordConfirm;
            (_a = this.form.get('repeatPassword')) === null || _a === void 0 ? void 0 : _a.resetError();
        }}>                                    
                                    <svg class="button__icon"><use href="/css/icons.svg#art-${this.shownPasswordConfirm ? 'eye-off' : 'eye'}"/></svg>
                                </button>
                                `} @enter="${this.signup}"></art-text-field>
                            </div>

                            <div class="btn-wrapper">
                                <button 
                                    class="button button--transparent" 
                                    @click="${this.signup}"
                                    ?disabled="${this.loading}"
                                >${this.translationService.instant('get_signup')}</button>
                            </div>
               
                            <p class="text text-center">
                                <span>${this.translationService.instant('av_already_have_an_account')}</span>
                                <span class="cursor-pointer art-ajaxer-popup-2" data-popup="login" ?disabled="${this.loading}"><b>${this.translationService.instant('av_log_in')}</b></span>
                            </p>
                            <div class="text-center text-xs signup_notice"> 
                                ${this.translationService.instant('sign_up_notice')} <a href="/privacy-notice">${this.translationService.instant('sign_up_notice_link')}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
    /**
     * Обратный вызов при успешной авторизации через соц.сеть
     */
    socialAuthSuccessCallback(redirect) {
        this.authService.socialLogin(redirect ? redirect : '');
        this.complete();
    }
    /**
     * Проверяет пароли
     */
    validateRepeatPasswordField() {
        const rpc = this.form.get('repeatPassword'), pc = this.form.get('password');
        if ((rpc === null || rpc === void 0 ? void 0 : rpc.getValue()) !== (pc === null || pc === void 0 ? void 0 : pc.getValue())) {
            this.form.setErrors({ password: this.translationService.instant('av_passwords_dont_match') });
        }
    }
    /**
     * Выполняет действия после аутентификации
     */
    complete() {
        const afterDoNothing = this.pageManager.checkActionAfterAuthenticated(this.pageManager.doNothing);
        if (!afterDoNothing) {
            this.popupService.open('loading', {});
            return;
        }
        this.popupService.close();
    }
};
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Boolean)
], LoginPopup.prototype, "loading", void 0);
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Boolean)
], LoginPopup.prototype, "shownPassword", void 0);
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Boolean)
], LoginPopup.prototype, "shownPasswordConfirm", void 0);
LoginPopup = __decorate([
    (0, decorators_js_1.customElement)('art-signup-popup'),
    __metadata("design:paramtypes", [])
], LoginPopup);
/**
 * Возвращает шаблон авторизации пользователя
 */
function getSignupTemplate() {
    return (0, lit_html_1.html) `<art-signup-popup></art-signup-popup>`;
}
exports.getSignupTemplate = getSignupTemplate;
window.PopupController.registerTemplate('signup', getSignupTemplate);
